import { fromJS, Map } from 'immutable';
import { getToken, setToken } from 'helpers/auth';

let initialState = Map();
const storage = {
  token: {
    path: ['user', 'token'],
    temp: null,
    getter: getToken,
    setter: setToken,
  },
  activeSpreadIds: {
    path: ['app', 'activeSpreadIds'],
    temp: null,
  },
};

export function localStoragePull() {
  Object.keys(storage).forEach(key => {
    const value = storage[key].getter ? storage[key].getter() : JSON.parse(localStorage.getItem(key));
    if (value) {
      storage[key].temp = fromJS(value);
      initialState = initialState.setIn(storage[key].path, storage[key].temp);
    }
  });

  return initialState;
}

export function localStoragePush(store) {
  store.subscribe(() => {
    const state = store.getState();

    const updating = [];
    const removing = [];

    Object.keys(storage).forEach(key => {
      const { path, temp } = storage[key];
      const currentValue = state.getIn(path);

      if (temp !== currentValue) {
        if (storage[key].setter) {
          updating.push(key);
          storage[key].setter(currentValue);
        } else {
          if (currentValue && (!storage[key].doSet || storage[key].doSet(state))) {
            updating.push(key);
            localStorage.setItem(key, JSON.stringify(currentValue));
          } else {
            removing.push(key);
            localStorage.removeItem(key);
          }
        }
        storage[key].temp = currentValue;
      }
    });

    if (updating.length > 0 || removing.length > 0) {
      p('Writing to localStorage', 'updating: [', updating.join(', '), '] removing: [', removing.join(', '), ']');
    }
  });
}

export function clearLocalStorage() {
  Object.keys(storage).forEach(key => {
    localStorage.removeItem(key);
  });
}



// WEBPACK FOOTER //
// ./app/helpers/localstorage-sync.js